import "./expertiseBox.component.css"

/**
 * Example component
 * @param title
 * @param description
 * @param logoURL
 * @param className Further class names
 * @param key Further keys
 * @return Example component
 */
function ExpertiseBoxComponent(
    props: Readonly<{
        title: string,
        description: string,
        logoURL: string,
        className?: string,
        [key: string]: any
    }>
) {
    const { className, title, description, logoURL, ...overflowProps } = props;

    return (
        <div className={`expertise-box ${className ?? ""}`} {...overflowProps}>
            <div className="flex items-center gap">
                <img className="expertise-logo" src={logoURL} width="50px" height="50px" />
                <h3>{title}</h3>
            </div>
            <p>{description}</p>
        </div>
    )
}

export default ExpertiseBoxComponent;